<script>
export default {
  name: "TutorIndex"
}
</script>

<template>
<router-view></router-view>
</template>

<style scoped>

</style>